import { purify } from '@vfit/shared/themes';
import { Container, DetailTitle, DetailDesc } from './consentsDetail.style';
import { IConsentsDetailProps } from './consentsDetail.models';

const ConsentsDetail = ({ consent }: IConsentsDetailProps) => {
  const [pDesc] = purify([consent.longDescription]);

  return (
    <>
      <Container>
        <div>
          <DetailTitle>{consent.name}</DetailTitle>
          <DetailDesc dangerouslySetInnerHTML={{ __html: pDesc || '' }} />
        </div>
      </Container>
    </>
  );
};

export default ConsentsDetail;

